import { Route } from '@angular/router';

export const SiteRoutes: Route[] = [
  {
    path: 'site',
    children: [
      {
        path: 'banner',
        loadComponent: () => import('../pages/site/banner/banner.page'),
      },
      {
        path: 'partner',
        loadComponent: () => import('../pages/site/partner/partner.page'),
      },
      {
        path: 'business-info',
        loadComponent: () =>
          import('../pages/site/business-info/business-info.page'),
      },
      {
        path: 'terms',
        loadComponent: () => import('../pages/site/terms/terms.page'),
      },
      {
        path: 'popup',
        loadComponent: () => import('../pages/site/popup/popup.page'),
      },
      {
        path: 'history',
        loadComponent: () => import('../pages/history/history.page'),
      },
      {
        path: 'certificate',
        loadComponent: () =>
          import('../pages/site/certificate/certificate.page'),
      },
    ],
  },
];
